import { Navigate } from "react-router-dom"

// DropInWorkspace — the legacy /settings/drop-in surface.
//
// Its check-in-mode Select + staff-check-in Switch (and the drop-in queue config
// and open_play pricing) now live in the Setup tab of the Drop-in service home
// (#143 slice 3, stage B2). This route is kept ONLY as a redirect so old links /
// bookmarks land on the live surface — there is no second editing path
// (clean-migration: one authoritative surface, not two). Mirrors /classes →
// /programs in router.tsx. The router still imports this export by name.
export function DropInWorkspace() {
  return <Navigate to="/services/drop-in?tab=setup" replace />
}
